/* eslint-disable no-underscore-dangle */
import React from 'react';
import { SbEditableContent } from 'storyblok-react';
import { blokToComponent } from '../../../../helpers';
import { Props } from '../../../../types';

type PageProps = Props<{ body: SbEditableContent[] }>;

export const FurtherContent = ({ blok, getComponent }: PageProps) => {
  const teasers = blok.further_content;

  const getTeaser = (index: number) => (teasers[index] ? [teasers[index]] : []);

  const headline = {
    _uid: `${blok._uid}-further-content-headline`,
    component: 'roche-headline',
    headline: 'Das könnte Sie auch interessieren',
    level: 2,
  };

  const grid = {
    _uid: `${blok._uid}-further-content-grid`,
    component: 'roche-grid-4-4-4',
    remove_padding_top: true,
    slotted_left: getTeaser(0),
    slotted_center: getTeaser(1),
    slotted_right: getTeaser(2),
  };

  const slider = {
    _uid: `${blok._uid}-further-content-grid`,
    component: 'roche-grid-12',
    slotted: [
      headline,
      {
        _uid: `${blok._uid}--further-content-slider`,
        component: 'roche-slider',
        slides_per_page: 3,
        slotted: teasers.map((teaser, index) => ({
          _uid: `${blok._uid}-slider-item-${index}`,
          component: 'roche-slider-item',
          slotted: teaser,
        })),
      }],
  };

  return <>
    {teasers.length <= 3 ? (
      <>
        {blokToComponent({
          blok: {
            _uid: `${blok._uid}-further-content-headline-grid`,
            component: 'roche-grid-12',
            slotted: [headline],
          },
          getComponent,
        })}

        {blokToComponent({
          blok: grid,
          getComponent,
        })}
      </>
    ) : (
      <>
        {blokToComponent({
          blok: slider,
          getComponent,
        })}
      </>
    )}
  </>;
};
